
        <siq-background></siq-background>

        <div class="progress">
            <siq-spinner [color]="'#fea621'"></siq-spinner>
            <h2 [innerHtml]="progress | async"></h2>
        </div>
    